export default () => ({
  agencyUser: undefined,
  agencyUsers: [],
  insureSignUsers: [],
  // Products starts as array. Can tell it's not loaded as there will always be products.
  products: [],
  hawkSoftCloudEnabled: undefined,
  agency: undefined,
  selectedInsureSignUsers: [],
  uniqueInsureSignUsers: [],
  registration: {},
  error: undefined,
  remoteAgencySeats: [],
  seatManagementDeletionError: false,
  seatManagementDeletionSuccess: false,
  seatManagementPendingRequests: [],
  // FeatureSwitches starts as null. more coding to handle, but it's possible to not have feature switches - using null, we can know that it hasn't been loaded yet.
  featureSwitches: null,
  agencyVersion: null,
  hasVersion5: false
});
